<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t('PageTitle.headline.idvPageHeader') }}
      </h1>
      <p class="bodycopy">
        {{ $t('PageSubTitle.paragraph.idvInstructions') }}
      </p>
    </div>
    <SkeleLoader
      v-if="isLoading"
      :lines="15"
      :hasContentImg="false"
      contentIsFullWidth
    />
    <!-- Plaid idv launches in head tag -->
    <div id="plaid-websdk" v-show="!isLoading" />
    <IdentityQueueNext />
  </div>

</template>

<script setup>
import {
 onBeforeMount, onBeforeUnmount, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';

// eslint-disable-next-line import/no-cycle
import usePlaidIframe from '@/composables/identity/usePlaidIframe';
import useApiHelpers from '@/composables/api/helpers';
import SkeleLoader from '@/components/ui/loaders/SkeleLoader.vue';
import IdentityQueueNext from '@/components/layout/progress/IdentityQueueNext.vue';
import IdentityQueueStepCounter from '@/components/layout/progress/IdentityQueueStepCounter.vue';

const router = useRouter();
const route = useRoute();
const { postRequest } = useApiHelpers();
const isLoading = ref(true);
const emit = defineEmits(['account-linked', 'plaid-link-error']);
let destroyLink;

onBeforeMount(async () => {
  const token = await postRequest('/plaid/kyc/token', {});
  const {
     addPlaidScriptElement,
     initialisePlaidLink,
     launchPlaidLink,
     isPlaidLoaded,
     destroyPlaidLink,
  } = usePlaidIframe(token.data.token, emit, route, router);
  isLoading.value = isPlaidLoaded.value;
  destroyLink = destroyPlaidLink;
  addPlaidScriptElement().onload = async () => {
    await initialisePlaidLink();
    launchPlaidLink();
  };
});

onBeforeUnmount(() => destroyLink());
</script>

<style lang="scss">
#plaid-websdk {
  min-height: 300px;
}

#plaid-link-iframe-1 {
  color-scheme: light;
}
</style>
